// Identité de la version affichée en permanence dans l’interface.
export const VERSION = {
  version: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0',
  builtAt: typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : new Date(0).toISOString(),
  commit: typeof __COMMIT__ === 'string' ? __COMMIT__ : 'local',
};

const fmtDay = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', day: 'numeric', month: 'short' });
const fmtTime = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit' });

/** 'v0.1.0 · 12 sept. 18:30 · a1b2c3d' */
export function versionLabel(v = VERSION): string {
  const d = new Date(v.builtAt);
  return `v${v.version} · ${fmtDay.format(d)} ${fmtTime.format(d)} · ${v.commit}`;
}
